import React from 'react'
import { arrow_tip, arrow_tip_dark } from '../../assets/images'
import TableData from '../../components/Engagement/Stepathon/TableData'
import { STEPATHON_LEADERBOARD as headers } from '../../constants/tableHeaders'
import leaderBoardTeamMemberSchema from './leaderBoardTeamMemberSchema'

const TeamListPageSchema = ({data, openIndividualData, IndividualData, arrowChange , onSearchHandler, index ,loading, memberLoading }) => {
  return (
    <React.Fragment>
    <tr className={index % 2  ?  'text-gray-600 bg-gray-50' : 'bg-white'} key={data.id}>
      <td className='pl-4 pr-4 py-4 font-semibold' style={{width: '14%'}}>{data.name}</td>
      <td className='pl-5 pr-4 py-4 justify-center' style={{width: '11%'}}> {data.size} </td>
      <td className='pl-4 py-4 ' style={{width: '20%'}}>{data.created_at}</td>
      <td className='py-4 pl-4' style={{width: '30%'}}>{data.created_by}</td>
      <td className='pl-5 items-center' style={{width: '20%'}}>
        <div className={arrowChange !== data.id ? 'w-10 h-9 rounded-md hover:bg-blue-100 hover:border-2 text-center cursor-pointer': 'w-full h-full cursor-pointer'}>
          <img 
            src={arrowChange === data.id ? arrow_tip_dark : arrow_tip} 
            alt='navigation-icon' 
            onClick={(e) => openIndividualData(e, data.id)}
            className={` ${arrowChange !== data.id ? 'transform -rotate-90 pt-7' : 'pl-3 pt-5'}`}
          />
        </div> 
      </td>
    </tr>
    {  arrowChange === data.id  &&
      <React.Fragment>
        <tr className='text-gray-600'>
        <td colSpan={6} className='shadow-inner border-2 bg-gray-100' >
        <TableData 
          arrowChange={arrowChange}
          onSearchHandler={onSearchHandler} 
          headers={headers.teams_members}
          inputClasses='bg-white' 
          key='team' 
          loading={memberLoading}
          steps={false}
          tableschema={leaderBoardTeamMemberSchema}
          IndividualData={IndividualData}
          individualList={true} 
          IconHandler={onSearchHandler}
          tableClasses='overflow-y-auto max-h-80'
          tableHeaderClasses='sticky top-0'
          Classes='mt-8 mx-20 mb-12'/>
        </td>
      </tr>
      </React.Fragment>
    }
  </React.Fragment>
  )
}

export default TeamListPageSchema